import { cn } from '@ais-ui/utils';

interface ErrorDisplayTableProps {
  message?: string;
  srcImage?: string;
  children?: React.ReactNode;
  className?: string;
}

export const ErrorDisplayTable = ({
  message = 'Something went wrong',
  srcImage = '/404_not_found_error_bro.avif',
  children,
  className,
}: ErrorDisplayTableProps) => {
  return (
    <div
      className={cn(
        'flex flex-col w-full max-w-full justify-center items-center self-center',
        className,
      )}
    >
      <img
        className="w-auto h-40 max-w-full object-contain"
        src={srcImage}
        alt="Error occurred"
        width={160}
        height={160}
        loading="lazy"
      />
      <div className="flex flex-col items-center justify-center space-y-2 w-full max-w-md px-4">
        <div className="text-muted-foreground text-center break-words -mt-4">
          {message}
        </div>
      </div>
      <div className="flex w-full max-w-md px-4 justify-center items-center">
        {children}
      </div>
    </div>
  );
};
